import styled from 'styled-components';
import { Card } from 'ui/card';
import { H4, body2, colors, smallShadow, spacing } from 'ui/theme';
import { normalPageMaxWidth } from 'ui/theme/spacing';

const Description = styled.div`
  ${body2}
  color: ${colors.secondaryText};
  margin-top: ${spacing.eighth};
`;

const StyledCard = styled(Card)`
  background: ${colors.white};
  display: flex;
  flex-direction: column;
  padding: ${spacing.plusHalf};
  max-width: ${normalPageMaxWidth};
  margin-bottom: ${spacing.plusHalf};

  border-radius: ${spacing.half};
  ${smallShadow};
`;

const Header = styled.div`
  margin-bottom: 0;
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: ${spacing.eighth};
  flex-wrap: wrap;
  gap: ${spacing.base};
`;

export type Props = {
  children: React.ReactNode;
  title: string;
  description: string;
  actions: React.ReactElement;
};

export const AlertsPageCard = ({ children, title, description, actions, ...props }: Props) => {
  return (
    <StyledCard {...props}>
      <Header>
        <HeaderRow>
          <H4>{title}</H4>
          {actions}
        </HeaderRow>
        <Description>{description}</Description>
      </Header>
      {children}
    </StyledCard>
  );
};
